import React, { ChangeEvent, FocusEvent, useState } from 'react';

import Button from 'components/common/Button/Button';
import TextInput from 'components/common/TextInput/TextInput';
import useForm, { FieldValues } from 'hooks/useForm';
import { validateCheckboxField, validateFirstName, validateRequiredField } from 'common/utils/validation.utils';
import Checkbox from 'components/common/Checkbox/Checkbox';

import styles from './ConfirmationOfCorrectContract.module.scss';
import { ConfirmationOfCorrectContractFieldName } from './confirmationOfCorrectContract.enums';

interface ConfirmationOfCorrectContractProps {
  onSubmit: () => void;
}

const ConfirmationOfCorrectContract = ({ onSubmit }: ConfirmationOfCorrectContractProps) => {
  const [isLoading, setLoading] = useState<boolean>(false);
  const { errors, values, setValue, validateField, handleSubmit } = useForm<FieldValues>({
    defaultValues: {
      [ConfirmationOfCorrectContractFieldName.FirstName]: '',
      [ConfirmationOfCorrectContractFieldName.LastName]: '',
      [ConfirmationOfCorrectContractFieldName.Confirmation]: false,
    },
    handleValidation: (fieldName, value) => {
      switch (fieldName) {
        case ConfirmationOfCorrectContractFieldName.FirstName: {
          return validateRequiredField(value, fieldName) || validateFirstName(value, fieldName);
        }
        case ConfirmationOfCorrectContractFieldName.LastName: {
          return validateRequiredField(value, fieldName) || validateFirstName(value, fieldName);
        }
        case ConfirmationOfCorrectContractFieldName.Confirmation: {
          return validateCheckboxField(value);
        }
        default:
          return '';
      }
    },
  });

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;

    if (name === ConfirmationOfCorrectContractFieldName.Confirmation) {
      setValue(name, !values[ConfirmationOfCorrectContractFieldName.Confirmation]);
    } else {
      setValue(name, value);
    }
  };

  const handleBlur = (event: FocusEvent<HTMLInputElement>) => {
    const { name } = event.target;

    validateField(name, values[name]);
  };

  const handleCorrectContractSubmit = handleSubmit(async () => {
    setLoading(true);
    await onSubmit();
    setLoading(false);
  });

  return (
    <div className={styles.container}>
      <ul className={styles.list}>
        <li className={styles.listItem}>Full Name of All Borrower(s)</li>
        <li className={styles.listItem}>Signature of All Borrower(s)</li>
        <li className={styles.listItem}>Full Address of Borrower(s)</li>
        <li className={styles.listItem}>Name or Logo of Company</li>
        <li className={styles.listItem}>Full Address of Company</li>
        <li className={styles.listItem}>Detailed Scope of Work</li>
        <li className={styles.listItem}>Total Cost of Project(s)</li>
      </ul>
      <TextInput
        className={styles.input}
        containerClassName={styles.inputContainer}
        labelTitle={ConfirmationOfCorrectContractFieldName.FirstName}
        name={ConfirmationOfCorrectContractFieldName.FirstName}
        tabIndex={1}
        errorMessage={errors[ConfirmationOfCorrectContractFieldName.FirstName]}
        onChange={handleChange}
        onBlur={handleBlur}
      />
      <TextInput
        className={styles.input}
        containerClassName={styles.inputContainer}
        labelTitle={ConfirmationOfCorrectContractFieldName.LastName}
        name={ConfirmationOfCorrectContractFieldName.LastName}
        tabIndex={2}
        errorMessage={errors[ConfirmationOfCorrectContractFieldName.LastName]}
        onChange={handleChange}
        onBlur={handleBlur}
      />
      <Checkbox
        label={ConfirmationOfCorrectContractFieldName.Confirmation}
        onChange={handleChange}
        name={ConfirmationOfCorrectContractFieldName.Confirmation}
        errorMessage={errors[ConfirmationOfCorrectContractFieldName.Confirmation]}
      />
      <Button className={styles.sendButton} onClick={handleCorrectContractSubmit} isLoading={isLoading}>
        Submit
      </Button>
    </div>
  );
};

export default ConfirmationOfCorrectContract;
